import { observer } from "mobx-react-lite";
import { ShippingLabelSettingsStore } from "../../../../stores/shipping-label-settings-store";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { Toggle } from "../../../../../../components/inputs/toggle/toggle";
import { IOption, SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import "./package-dimensions-fields.scss";
import { CP_DIMENSION_UNIT } from "../../../../return-method-types";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import { FormField } from "../../../../../../components/form-field/form-field";
import { Input } from "../../../../../../components/inputs/input/input";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";


interface IPackageDimensionsFieldsProps {
    shippingLabelStore?: ShippingLabelSettingsStore;
    validationGroup: IValidationGroup;
}

const PackageDimensionsFields: React.FC<IPackageDimensionsFieldsProps> = observer(({shippingLabelStore, validationGroup}: IPackageDimensionsFieldsProps) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-return-method-editor';

    const dimensionUnitList: IOption[] = [
        {label: "cm", value: CP_DIMENSION_UNIT.CM }, {label: "in", value: CP_DIMENSION_UNIT.IN }
    ];
    const selectedDimensionUnit: IOption | undefined = dimensionUnitList.find(unit => unit.value === shippingLabelStore?.cpDimensionsUnit ); 

    return(
        <>
            <FormFieldLine
                label={getTranslation("USE_CUSTOM_PACKAGE_DIMENSIONS", scope)}
                note={getTranslation("USE_CUSTOM_PACKAGE_DIMENSIONS_NOTE", scope)}
            >
                <Toggle
                    label=""
                    checked={shippingLabelStore?.useCustomPackage}
                    disabled={shippingLabelStore?.mustHaveCustomDimensions()}
                    onChange={(v) => shippingLabelStore?.setUseCustomPackage(v as boolean)}
                />
            </FormFieldLine>
            {!!shippingLabelStore?.useCustomPackage &&
                <div className="package-dimensions">
                    <FormField label={getTranslation("LENGTH", scope)} required>
                        <Input type="number" temp
                            value={shippingLabelStore?.cpLength as number}
                            validationGroup={validationGroup}
                            onChange={v => shippingLabelStore?.setCpLength(v)}
                            validationCallback={shippingLabelStore.validateCpLength}
                            required
                        />
                    </FormField>
                    <FormField label={getTranslation("WIDTH", scope)} required>
                        <Input type="number" temp
                            value={shippingLabelStore?.cpWidth as number}
                            validationGroup={validationGroup}
                            onChange={v => shippingLabelStore?.setCpWidth(v)}
                            validationCallback={shippingLabelStore.validateCpWidth}
                            required
                        />
                    </FormField>
                    <FormField label={getTranslation("HEIGHT", scope)} required>
                        <Input type="number" temp
                            value={shippingLabelStore?.cpHeight as number}
                            validationGroup={validationGroup}
                            onChange={v => shippingLabelStore?.setCpHeight(v)}
                            validationCallback={shippingLabelStore.validateCpHeight}
                            required
                        />
                    </FormField>
                    <FormField label={getTranslation("DIMENSION_UNIT", scope)} required>
                        < SelectDropdown
                            value={selectedDimensionUnit}
                            options={dimensionUnitList}
                            onChange={(v) => { shippingLabelStore?.setCpDimensionsUnit(v?.value as CP_DIMENSION_UNIT)}}
                            required
                            validationGroup={validationGroup}
                        />
                    </FormField>
                </div>
            }
        </>
    )
}) 

export default PackageDimensionsFields;